'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'

import text from 'fukku/styles/texts.module.scss'

export function Disclaimer({ isCorner }: { readonly isCorner: boolean }) {
	const { t } = useLabels()

	return (
		<>
			<p className={text.bodyS}>
				{t('storeFinder.storeDetails.infoStock.text')}
			</p>
			{isCorner && (
				<p className={text.bodyS}>
					{t('storeFinder.storeDetails.infoReturns.text')}
				</p>
			)}
		</>
	)
}
